import * as React from 'react';
import { Config } from '../../../helper';

function SpecializationField({value}) {
  if (Array.isArray(value)) return value.join(', ');
  return value || '';
}

export default function ResearchFocusGroup({specialization, institutionName}) {
  const hasSpecialization = Array.isArray(specialization) ? specialization.length > 0 : !!specialization;
  const hasInstitution = !!institutionName;
  if (!hasSpecialization && !hasInstitution) return null;

  return (
    <div className='fields-group'>
      <div className='field field--heading text-bold'>{Config.I18n.ProfileTeaser.ResearchFocus}</div>
      {hasSpecialization && (
        <div className='field field--heading field--specialization'>
          <SpecializationField value={specialization}/>
        </div>
      )}
      {hasInstitution && (
        <div className='field field--institution-name'>{institutionName}</div>
      )}
    </div>
  );
}
